import React from 'react';
import { Box, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import styles from './CreateConfigHeader.styles';

export default function CreateConfigHeader({ title = 'Create Configurations' }) {
  return (
    <Box sx={styles.headerRow}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <AddCircleOutlineIcon sx={{ ...styles.pageTitle, mr: 1 }} />
        <Typography sx={styles.pageTitle}>{title}</Typography>
      </Box>
    </Box>
  );
}
